import { BaseImageSettings } from '../../hooks/useImageSettings';
import { AddToCartSelection } from './add-to-cart-drawer.types';

export const ADD_TO_CART_DRAWER_NAME = 'add-to-cart-drawer';

export const ADD_TO_CART_DRAWER_IMAGE_VIEWPORT_SETTINGS: BaseImageSettings = {
    xs: 'small',
    sm: 'small',
    md: 'small',
    lg: 'small',
    xl: 'small'
};

export const EMPTY_ADD_TO_CART_SELECTION: AddToCartSelection = {
    productRecordId: undefined,
    color: undefined,
    size: undefined,
    sizeRequiredError: false
};

export const SKELETON_NUMBER_OF_OPTIONS_TO_SHOW = 4;
